import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnOptionsComponent } from './return-options.component';
import { MatCardModule } from '@angular/material/card';
import { HeaderModule } from '../header/header.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';
import { BackButtonConfirmationModalModule } from '../back-button-confirmation-modal/back-button-confirmation-modal.module';

@NgModule({
  declarations: [
    ReturnOptionsComponent
  ],
  imports: [
    CommonModule, HeaderModule, MatCardModule, ProgressBarModule, BackButtonConfirmationModalModule
  ],
  exports : [
    ReturnOptionsComponent
  ]
  
})
export class ReturnOptionsModule { }